module.exports = __webpack_public_path__ + "error.f2735059.svg";